import { useEffect } from "react";

/** Shared wrapper for /politique-confidentialite, /conditions-utilisation, /politique-cookies. */
export default function LegalPage({ title, lastUpdated = "30 juin 2026", children }) {
  useEffect(() => { document.title = `${title} · Lokaso`; }, [title]);
  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <h1 className="font-display text-3xl md:text-5xl font-bold text-lokaso-green">{title}</h1>
        <p className="mt-2 text-sm text-stone-500">Dernière mise à jour : {lastUpdated}</p>
        <hr className="my-6 border-stone-200" />
        <article className="prose prose-stone max-w-none
                            prose-h2:text-lokaso-green prose-h2:mt-8 prose-h2:font-display
                            prose-h3:text-lokaso-dark prose-h3:font-display
                            prose-a:text-lokaso-green prose-a:no-underline hover:prose-a:underline
                            prose-strong:text-lokaso-dark">
          {children}
        </article>
        <p className="mt-10 text-xs text-stone-400 text-center">© 2026 Lokaso — Tous droits réservés.</p>
      </div>
    </div>
  );
}
